const toPercent = (num, total) => (num / total) * 100;

export default toPercent;
